import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import WarningBadge from './WarningBadge';
import './RegisterStatusBadge.less';
import {
  formatRegisterStatusSince,
  getRegisterStatusName,
  isNonActiveRegisterStatus
} from '../../utils/companyStatus';

/**
 * Marks a company that no longer trades normally (in liquidation, dissolved, ...)
 * with the existing warning badge. Active and unknown companies get nothing, so the badge
 * stays a signal rather than a label on every row.
 */
const RegisterStatusBadge = observer(
  ({ company, tooltipPosition = 'bottom-start', badgeClassName = '' }) => {
    if (!isNonActiveRegisterStatus(company?.companyStatus)) return null;

    const since = formatRegisterStatusSince(
      company.companyStatusSince,
      company.companyStatusSincePrecision
    );

    const tooltipContent = since
      ? `Register status from Creditreform, ${since}`
      : 'Register status from Creditreform';

    return (
      <WarningBadge
        label={getRegisterStatusName(company.companyStatus)}
        tooltipContent={tooltipContent}
        tooltipPosition={tooltipPosition}
        badgeClassName={['register-status-badge', badgeClassName].filter(Boolean).join(' ')}
      />
    );
  }
);

RegisterStatusBadge.propTypes = {
  company: PropTypes.shape({
    companyStatus: PropTypes.string,
    companyStatusSince: PropTypes.string,
    companyStatusSincePrecision: PropTypes.string
  }),
  tooltipPosition: PropTypes.string,
  badgeClassName: PropTypes.string
};

export default RegisterStatusBadge;
